import { z } from "zod";
import type { TFunction } from "i18next";

export const createResetPasswordSchema = (t: TFunction) =>
  z
    .object({
      newPassword: z.string().trim(),
      confirmPassword: z.string().trim(),
    })
    .superRefine((values, ctx) => {
      if (!values.newPassword) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["newPassword"],
          message: t("auth.new_password_required"),
        });
      } else if (values.newPassword.length < 8) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["newPassword"],
          message: t("auth.password_too_short"),
        });
      }

      if (!values.confirmPassword) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["confirmPassword"],
          message: t("auth.confirm_password_required"),
        });
      } else if (values.newPassword !== values.confirmPassword) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["confirmPassword"],
          message: t("auth.passwords_do_not_match"),
        });
      }
    });

export type ResetPasswordSchema = ReturnType<typeof createResetPasswordSchema>;
export type ResetPasswordFormValues = z.output<ResetPasswordSchema>;
